export default "__VITE_ASSET__BnOLyROV__"